import React from 'react';
import PropTypes from 'prop-types';
import SubmitButton from './SubmitButton';
import './BottomStickyContainer.scss';

const BottomStickyContainer = (props) => {
  const { children, ...otherProps } = props;
  const {
    onShowModal,
    learnosityData: { app, items },
  } = otherProps;

  return (
    <div className="bottom-sticky-container">
      {children && React.cloneElement(children, otherProps)}
      <SubmitButton onShowModal={onShowModal} app={app} items={items} />
    </div>
  );
};

BottomStickyContainer.displayName = 'BottomStickyContainer';

BottomStickyContainer.propTypes = {
  onShowModal: PropTypes.func,
  learnosityData: PropTypes.object,
};

BottomStickyContainer.defaultProps = {
  onShowModal: () => {},
  learnosityData: {},
};

export default BottomStickyContainer;
